var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result",on:{"click":_vm.subscribe}},[_c('h1',{staticClass:"security-name"},[_vm._v(_vm._s(_vm.security.ticker))]),_vm._v(" "),_c('h3',{staticClass:"family-name"},[_vm._v(_vm._s(_vm.security.fundfamilyname))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058855b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = Iqdl
// module chunks = 0